import React, { useEffect, useState } from 'react';

const DepositReportPrint = () => {
    const [report, setReport] = useState(null);

    useEffect(() => {
        const stored = localStorage.getItem('print_report_details');
        if (stored) {
            const parsed = JSON.parse(stored);
            if (parsed.payments) {
                // Sort payments Oldest to Newest
                parsed.payments.sort((a, b) => new Date(a.payment_date) - new Date(b.payment_date));
            }
            setReport(parsed);
        }
        setTimeout(() => window.print(), 900);
    }, []);

    if (!report) return <div className="p-8 text-center">جاري تحميل البيانات...</div>;

    const formatDate = (d) => {
        if (!d) return '--';
        try { return new Date(d).toLocaleDateString('fr-MA'); } catch { return d; }
    };

    const fmt = (n) => Number(n).toLocaleString('fr-MA', { minimumFractionDigits: 2 });

    return (
        <div className="report-wrapper" dir="rtl">
            {/* ══ Header ══════════════════════════════════════════════════════ */}
            <div className="report-header">
                <div className="header-logo-side">
                    <img src="/logo.png" alt="شعار الجمعية" className="header-logo" />
                    <div>
                        <p className="assoc-name">جمعية تنمية النقل المدرسي</p>
                        <p className="assoc-sub">ولاد دحو</p>
                    </div>
                </div>
                <div className="header-title-side">
                    <h1 className="report-title">تقرير الإيداع البنكي</h1>
                    <p className="report-period">
                        رقم التقرير: <strong>{report.report_number}</strong>
                    </p>
                    <p className="report-print-date">تاريخ الإيداع: {formatDate(report.report_date)}</p>
                </div>
            </div>

            {report.notes && (
                <div className="notes-box">
                    <strong>ملاحظات:</strong> {report.notes}
                </div>
            )}

            {/* ══ Main Table ══════════════════════════════════════════════════ */}
            <table className="main-table">
                <thead>
                    <tr>
                        <th className="col-num">#</th>
                        <th className="col-date">تاريخ الدفع</th>
                        <th className="col-receipt">وصل رقم</th>
                        <th className="col-name">اسم التلميذ</th>
                        <th className="col-mode">وسيلة الدفع</th>
                        <th className="col-amount">المبلغ</th>
                    </tr>
                </thead>
                <tbody>
                    {report.payments?.map((p, idx) => (
                        <tr key={p.id} className={idx % 2 === 0 ? 'row-even' : 'row-odd'}>
                            <td className="td-center">{idx + 1}</td>
                            <td className="td-center">{formatDate(p.payment_date)}</td>
                            <td className="td-center">{p.id}</td>
                            <td className="td-name">{p.student?.full_name || '--'}</td>
                            <td className="td-center">{p.payment_mode_details?.name || p.payment_mode || '--'}</td>
                            <td className="td-amount">{fmt(p.amount)} د.م</td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr className="footer-total">
                        <td colSpan="5" className="td-right">المجموع الإجمالي</td>
                        <td className="td-amount">{fmt(report.total_amount)} د.م</td>
                    </tr>
                </tfoot>
            </table>

            {/* ══ Summary ══════════════════════════════════════════════════════ */}
            <div className="summary-section">
                <p>عدد العمليات الإجمالي: <strong>{report.payments_count}</strong></p>
                <p>المبلغ بالحروف: ...................................................................................................................</p>
            </div>

            {/* ══ Footer ══════════════════════════════════════════════════════ */}
            <div className="report-footer">
                <div className="footer-sign">
                    <span>توقيع أمين المال</span>
                    <div className="sign-line" />
                </div>
                <div className="footer-sign">
                    <span>توقيع الرئيس</span>
                    <div className="sign-line" />
                </div>
                <div className="footer-sign">
                    <span>ختم الجمعية</span>
                    <div className="sign-line" />
                </div>
            </div>

            {/* ══ Styles ══════════════════════════════════════════════════════ */}
            <style dangerouslySetInnerHTML={{ __html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;600;700&display=swap');
                * { box-sizing: border-box; margin: 0; padding: 0; }
                body { font-family: 'Cairo', sans-serif; background: #fff; color: #111; direction: rtl; }
                .report-wrapper { width: 210mm; margin: 0 auto; padding: 10mm; }
                .report-header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 15px; }
                .header-logo-side { display: flex; align-items: center; gap: 12px; }
                .header-logo { height: 60px; }
                .assoc-name { font-size: 14px; font-weight: 700; }
                .assoc-sub { font-size: 12px; color: #555; }
                .header-title-side { text-align: left; }
                .report-title { font-size: 20px; font-weight: 700; margin-bottom: 5px; }
                .report-period { font-size: 12px; }
                .report-print-date { font-size: 12px; color: #444; }
                .notes-box { padding: 10px; border: 1px dashed #999; margin-bottom: 15px; font-size: 12px; background: #f9f9f9; }
                .main-table { width: 100%; border-collapse: collapse; font-size: 12px; margin-bottom: 20px; }
                .main-table th { background: #f2f2f2; padding: 8px; border: 1px solid #000; text-align: center; }
                .main-table td { border: 1px solid #000; padding: 6px; }
                .td-center { text-align: center; }
                .td-name { font-weight: 600; }
                .td-amount { text-align: center; font-weight: 700; width: 100px; }
                .td-right { text-align: right; font-weight: 700; padding-right: 20px; }
                .footer-total td { background: #eee; font-size: 14px; }
                .summary-section { margin-bottom: 30px; font-size: 13px; }
                .report-footer { display: flex; justify-content: space-around; margin-top: 40px; }
                .footer-sign { text-align: center; font-size: 13px; font-weight: 600; width: 150px; }
                .sign-line { border-top: 1px solid #000; width: 100%; margin: 40px auto 0; }
                @media print {
                    @page { size: A4 portrait; margin: 0; }
                    .report-wrapper { width: 100%; padding: 10mm; }
                }
            `}} />
        </div>
    );
};

export default DepositReportPrint;
